import React, { useState, useEffect, Fragment, } from 'react';
import axiosInstance from '../container/utils/axios';

const NextMarket = () => {
    const [post, setPost] = useState([]);

    useEffect(() => {
        const fetchAPI = async () => {

            const res = await axiosInstance
                .get('/events')
                .then(res => {
                    let resData = res.data
                    setPost(resData)
                })
                .catch(err => console.log(err))
            return res;

        }

        fetchAPI();
    }, [])

    const marketEvent = post.map(event => {
        return <div className="post-pageDesc" key={event.id}>{event.eventText}</div>
    })


    return (
        <Fragment>
            <div className='announcement-context'>
                {marketEvent}
            </div>
        </Fragment>
    )
}

export default NextMarket;
